import Box from '@zuto/core/src/box'
import { GridItem } from '@zuto/core/src/grid'
import React from 'react'
import { RepRatesBySource } from '../../GlobalVariables/RepRates'

const getBannersList = (sourceName: string): JSX.Element => {
  const rates = RepRatesBySource[sourceName] || RepRatesBySource.default

  if (sourceName === 'moneysupermarket') {
    return (
      <div data-testid="moneysupermarket-rate">
        Zuto is a credit broker not a lender:<br />
        Our rates start from {rates.startFrom}, representative {rates.repAPR} APR
      </div>
    )
  }

  const defaultBanner = `Zuto rates from ${rates.startFrom} APR. Representative APR of ${rates.repAPR}.`
  return <div data-testid="default-rate">{defaultBanner}</div>
}

interface RepresentativeExampleProps {
  sourceName?: string
}

const RepresentativeExample = ({ sourceName = 'default' }: RepresentativeExampleProps): JSX.Element => {
  const representativeExampleText = getBannersList(sourceName)

  return (
    <GridItem gridColumn={['auto / span 12', '3 / span 8']} gridRow={['auto', '2 / auto']}>
      <Box as="p" textStyle="body.xsPrint.regular"
        style={{ marginTop: sourceName === 'moneysupermarket' ? 0 : '12px' }}>
        {representativeExampleText}
      </Box>
    </GridItem>
  )
}

export default RepresentativeExample
